// Audio Player with slider

import { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player'

import playicon from "../img/play_dark.svg";
import pauseicon from "../img/pause_dark.svg";

import seekback from "../img/replay_10.svg";
import seekforward from "../img/forward_10.svg";

import loadingicon from "../img/loading2.svg";

import captionicon from "../img/captions.svg";
import captiondark from "../img/captions-dark.svg";

function ContentAudio(props) {

  const ref = useRef(null)

  const [playing, setplaying] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const [duration, setDuration] = useState(0);

  const [videoLoaded, setVideoLoaded] = useState(false);

  const [loading, setLoading] = useState(true);

  const [showCaptions, setShowCaptions] = useState(props.content?.captionsdefault || false);

  useEffect(() => {
    if (!props.active) {
      setplaying(false);
    } 
  }, [props.active])

  const handleSeekChange = e => {
    setSeconds(parseFloat(e.target.value))
    ref.current.seekTo(parseFloat(e.target.value));
  }

  const formatTime = (s) => {
  const minutes = Math.floor(s / 60);
  const seconds = Math.floor(s % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}

 useEffect(() => {
    console.log(duration);
  }, [duration])


  return (
    <div className="page-content-audio" style={{backgroundColor: props.content?.backgroundcolor ? props.content.backgroundcolor : '#222'}}>
      <ReactPlayer
        ref={ref}
        playing={playing}
        url={props.baseurl + props.content.url}
        style={{ display: 'none' }}
        onProgress={(e) => setSeconds(e.played)}
        onEnded={() => props.onEnd()}
        onDuration={setDuration}
        onWaiting={() => setLoading(true)}
        onReady={() => setLoading(false)}
        playsinline
        progressInterval={200}
      />

      {props.content.captions && showCaptions && <div className='audiocaptions'>
        {props.content.captions}
      </div>}

      <div className='audiocontrols' style={{flexDirection: 'column'}}>
        <div className='audioplaybuttoncontainer'>
          <div className='audioplaysecondarybutton clickable' onClick={() => ref.current.seekTo(seconds - 10 / duration)}><img src={seekback}  /></div>
          { loading ?
            <div className={'audioplayicon audioplayiconloading'}><img src={loadingicon} /></div>
            :
            <div onClick={() => setplaying(!playing)} className={'audioplayicon clickable'}><img src={playing ? pauseicon : playicon} /></div>
          }
          {props.content.captions ?
            <div className={`audioplaysecondarybutton ${showCaptions ? "audioplaysecondarybuttonactive" : ""} clickable`} onClick={() => setShowCaptions(!showCaptions)}><img src={showCaptions ? captiondark : captionicon }  /></div>
          :
          <div className='audioplaysecondarybutton clickable' onClick={() => ref.current.seekTo(seconds + 10 / duration)}><img src={seekforward}  /></div>
          }
        </div>

        <input
        type='range' min={0} max={0.999999} step='any'
        value={seconds}
        onChange={handleSeekChange}
        className='audiobar'
      />
      <div className="time-display">
        <span>{formatTime(seconds * duration)}</span>
        <span>{formatTime(duration)}</span>
      </div>
      </div>

      <div className={`audiogradient ${showCaptions ? "audiogradientcaptions" : ""}`}></div>

      {props.content?.backgroundvideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          className={`audiobackgroundvideo`}
          style={{
            opacity: videoLoaded ? 1 : 0,
          }}
          onCanPlayThrough={() => setVideoLoaded(true)}
        >
          <source src={props.baseurl + props.content?.backgroundvideo} type="video/mp4" />
        </video>
      )}

      {props.content.imageurl && <img className='audiobackground' src={props.baseurl + props.content.imageurl} />}

      {props.content?.imagecopyright && <span className='imagecopyright'>{"© " + props.content?.imagecopyright}</span>}
      
    </div>
  );
}

export default ContentAudio;
